@if (!noFormNeeded) {
<div class="p-t p-b">
    <!-- loading js info -->
    @if (scriptStatus.busy) {
    <div class="p-a center c1">
        Initializing...
    </div>
    }
    <!-- js load failur info -->
    <result [status]="scriptStatus"
            duration="permanent"></result>
    <!-- card form -->
    <div [hidden]="!isInitialized">
        <label class="_required block c1 m-t-4">Name on card</label>
        <div #cardHolder
             class="b-a p-a-4 m-t-2 bg-col-w"></div>
        <div #cardHolderError
             class="m-t-1 c1 col-2"></div>
        <label class="_required block c1 m-t-4">Card Number</label>
        <div #cardNumber
             class="b-a p-a-4 m-t-2 bg-col-w"></div>
        <div #cardNumberError
             class="m-t-1 c1 col-2"></div>
        <label class="_required block c1 m-t-4">Expiry Date</label>
        <div #cardExpiry
             class="b-a p-a-4 m-t-2 bg-col-w"></div>
        <div #cardExpiryError
             class="m-t-1 c1 col-2"></div>
        <label class="_required block c1 m-t-4">CVC/CVV</label>
        <div #cardCvc
             class="b-a p-a-4 m-t-2 bg-col-w"></div>
        <div #cardCvcError
             class="m-t-1 c1 col-2"></div>
    </div>
</div>
}